import request from "/@/api/http/requestOther";
// 获取 ai流配置列表
export const getAiflowListApi = async function (params: any) {
  const url = `/ai/api/aiStream/page?current=${params.current}&size=${params.size}&workspace=${params.workspace}&sn=${params.sn}&streamType=${params.streamType}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 ai流配置列表
export const delAiflowListApi = async function (id: any) {
  const url = `/ai/api/aiStream/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 开启 ai流配置列表
export const startAiflowApi = async function (id: any) {
  const url = `/ai/api/aiStream/start?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 关闭 ai流配置列表
export const stopAiflowApi = async function (id: any) {
  const url = `/ai/api/aiStream/stop?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 ai流配置列表
export const addAiflowListApi = async function (data: any) {
  const url = `/ai/api/aiStream/save`;
  const result = await request.post(url, data);
  return result.data;
};
// 编辑 ai流配置列表
export const editAiflowListApi = async function (data: any) {
  const url = `/ai/api/aiStream/update`;
  const result = await request.post(url, data);
  return result.data;
};
// 获取 ai流配置 模型文件
export const getAimodelListApi = async function () {
  const url = `/ai/api/aiStream/getPt`;
  const result = await request.get(url);
  return result.data;
};
// 获取 ai流配置 模型文件列表
export const getAimodelApi = async function (params: any) {
  const url = `/ai/api/aiModel/page?current=${params.current}&size=${params.size}&name=${params.name}&workspace=${params.workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 ai流配置 模型文件列表
export const delAimodelApi = async function (id: any) {
  const url = `/ai/api/aiModel/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 ai 模型文件
export const addAiModelApi = async function (data: any) {
  const url = `/ai/api/aiModel/save`;
  const result = await request.post(url, data);
  return result.data;
};
// 编辑 ai 模型文件
export const editAiModelApi = async function (data: any) {
  const url = `/ai/api/aiModel/update`;
  const result = await request.post(url, data);
  return result.data;
};
// 获取 ai执行文件 列表
export const getAiExecuteApi = async function (params: any) {
  const url = `/ai/api/aiExecute/page?current=${params.current}&size=${params.size}&name=${params.name}&workspace=${params.workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 ai执行文件 列表
export const delAiExecuteApi = async function (id: any) {
  const url = `/ai/api/aiExecute/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 ai 执行文件
export const addAiExecuteApi = async function (data: any) {
  const url = `/ai/api/aiExecute/save`;
  const result = await request.post(url, data);
  return result.data;
};
// 编辑 ai 执行文件
export const editAiExecuteApi = async function (data: any) {
  const url = `/ai/api/aiExecute/update`;
  const result = await request.post(url, data);
  return result.data;
};
// 获取字典
export const getDictionListApi = async function (params: any) {
  let workspace = params.workspace || ''
  const url = `/ai/api/dictionaries/page?current=${params.current}&size=${params.size}&faId=${params.faId}&workspace=${workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 日志
export const getLogListApi = async function (params: any) {
  const url = `/ai/api/aiStream/getLog?id=${params.id}`;
  const result = await request.get(url);
  return result.data;
};
// 机场sn查找 输入输出流
export const getFlowBySnApi = async function (sn: any) {
  const url = `/ai/api/gb28181/getBySn?sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 开启 预警任务
export const startAiStreamApi = async function (data: any) {
  const url = `/ai/api/aiStream/startAiStream`;
  const result = await request.post(url,data);
  return result.data;
};
// 关闭 预警任务
export const stopAiStreamApi = async function (data: any) {
  const url = `/ai/api/aiStream/stopAiStream`;
  const result = await request.post(url,data);
  return result.data;
};

// ==================== 提示词配置接口 ====================

// 获取提示词配置列表（分页）
export const getPromptConfigPageApi = async function (params: {
  current: number;
  size: number;
  confName?: string;
}) {
  const url = `/vlmr1/sysConf/page?current=${params.current}&size=${params.size}&confName=${params.confName || ''}`;
  const result = await request.get(url);
  return result.data;
};

// 新增提示词配置
export const savePromptConfigApi = async function (data: any) {
  const url = `/vlmr1/sysConf/save`;
  const result = await request.post(url, data);
  return result.data;
};

// 修改提示词配置
export const updatePromptConfigApi = async function (data: any) {
  const url = `/vlmr1/sysConf/update`;
  const result = await request.post(url, data);
  return result.data;
};

// 删除提示词配置
export const deletePromptConfigApi = async function (id: number | string) {
  const url = `/vlmr1/sysConf/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
